import React from "react";

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Tag,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper
} from "@chakra-ui/react";
import { Controller } from 'react-hook-form-7';

import FormDescription from '../../../utils/chakra/FormDescription';

import useTranslations from '../../../../hooks/useTranslations';
import useTextInputFocus from '../../hooks/useTextInputFocus';
import useQuestionErrors from '../../hooks/useQuestionErrors';

import { QuestionProps } from './types/QuestionProps';

const QuestionTimeTracking: React.FC<QuestionProps> = 
  ({ question, control, path }) => {
    const t = useTranslations();
    const { onFocus, onBlur } = useTextInputFocus();
    const { isInvalid, errorMessage } = useQuestionErrors({
      control,
      name: `${path}.timeSpent`,
    });

    return (
      <FormControl
        isInvalid={isInvalid}
        isRequired={question.required}
        id={`${path}.timeSpent`}
      >
        <FormLabel fontWeight="medium" fontSize="md" color="gray.500">
          {t("reports.edit.evaluateTimeSpent")}
        </FormLabel>
        {question?.expectedTimeValue && (
          <FormDescription>
            <Tag variant="solid" colorScheme="purple">
              {t("reports.expectedTime.hours", {
                count: question.expectedTimeValue,
              })}
            </Tag>
          </FormDescription>
        )}
        <Controller
          control={control}
          name={`${path}.timeSpent` as const}
          rules={{
            required:
              question.required &&
              (t("reports.shared.requiredQuestion") as string),
          }}
          render={({ field: { onBlur: fieldBlur, ...fieldMethods } }) => (
            <NumberInput
              // This looks rather ugly but native form validation block the one made by RHF
              isRequired={false}
              aria-required={question.required ? "true" : "false"}
              maxW="xs"
              onFocus={onFocus()}
              onBlur={onBlur(fieldBlur)}
              {...fieldMethods}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          )}
        />

        <FormErrorMessage color="invalid.500">{errorMessage}</FormErrorMessage>
      </FormControl>
    );
  }
;

export default React.memo(QuestionTimeTracking)